import axios from "axios";
import { baseURL } from "./ApiURL"


/*
==================================================================================
TRACKING
==================================================================================
*/
export async function getTrackingxVendedor(CodVendedor) {
  try {
    var res;
    if (CodVendedor === 'none') {
      res = await axios.get(baseURL + `/TrackPedidosVendedor`);
    } else {
      res = await axios.get(baseURL + `/TrackPedidosVendedor?CodVendedor[eq]=${CodVendedor}`);
    }
    return res.data;
  } catch (error) {
    console.error(error)
  }
}

export async function getTrackingxZona(CodSupervisor, Zona, page) {
  try {
    var res;
    if (page !== 0) {
      res = await axios.get(baseURL + `/getTrackingxZonaSupervisor?CodSupervisor=${CodSupervisor}&Zona=${Zona}&page=${page}`)
     
  } else {
    res = await axios.get(baseURL + `/getTrackingxZonaSupervisor?CodSupervisor=${CodSupervisor}&Zona=${Zona}`)
  }
    return res.data;
  } catch (error) {
    console.error(error)
  }
}

export async function SearchTracking(Documento) {
  try {
    const res = await axios.get(baseURL + `/getTrackingDetalle?Documento=${Documento}`);
    return res;
  } catch (error) {
    console.error(error)
  }
}

export async function SearchTrackingSupervisor(CodSupervisor,Documento) {
  try {
    const res = await axios.get(baseURL + `/getTrackingxZonaSupervisorDocumento?CodSupervisor=${CodSupervisor}&Documento=${Documento}`);
    return res;
  } catch (error) {
    console.error(error)
  }
}

export async function SearchTrackingSupervisorCliente(CodSupervisor,Cliente) {
  try {
    const res = await axios.get(baseURL + `/getTrackingxZonaSupervisorCliente?CodSupervisor=${CodSupervisor}&Cliente=${Cliente}`);
    return res;
  } catch (error) {
    console.error(error)
    return []
  }
}

export async function TrackingDetalle(Documento) {
  try {
    const res = await axios.get(baseURL + `/getTrackingDetalle?Documento=${Documento}`);
    return res;
  } catch (error) {
    console.error(error)
  }
}

export async function SearchTrackingbyFechas(CodVendedor, fechaInicio, fechaFin) {
  try {
    const res = await axios.get(baseURL + `/getTrackingPorFecha?CodVendedor=${CodVendedor}&fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`);
    return res.data;
  } catch (error) {
    console.error(error)
  }
}

export async function SearchTrackingbyFechasSupervisor(CodSupervisor, fechaInicio, fechaFin) {
  try {
    const res = await axios.get(baseURL + `/getTrackingxZonaSupervisorFecha?CodSupervisor=${CodSupervisor}&fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`);
    return res.data;
  } catch (error) {
    console.error(error)
  }
}


export async function SearchTrackingbyCliente(CodVendedor, NombreCliente) {
  try {
    const res = await axios.get(baseURL + `/getTrackingCliente?CodVendedor=${CodVendedor}&NombreCliente=${NombreCliente}`);
    return res.data;
  } catch (error) {
    console.error(error)
  }
}